// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__33M9B","modal":"Modal_modal__qMSrP","keyframe-fade-in":"Modal_keyframe-fade-in__3UE3g"};